import { makeStyles } from "@material-ui/core/styles"

export const useSelectWrap = makeStyles({
    selectLine: {
        display: "flex",
        width: "100%",
        flexGrow: 1,
        position: "relative",
    },
    weChatLine: {
        "&:nth-child(5n + 1)": {
            marginTop: 20,
            borderTop: "2px solid #ddd",
        },
    },
})
